/**
 *
 */
/**
 *
 */ export var MappingMode;
(function (MappingMode) {
    /**
     *
     */
    MappingMode[MappingMode["CUBE"] = 0] = "CUBE";
    /**
     *
     */
    MappingMode[MappingMode["LINEAR"] = 1] = "LINEAR";
    /**
     *
     */
    MappingMode[MappingMode["RADIAL"] = 2] = "RADIAL";
})(MappingMode || (MappingMode = {}));



// WEBPACK FOOTER //
// ../dist/lib/textures/MappingMode.js